import { actionCreator } from '@ardoq/rxbeach';
import { PayloadIsSuppressed } from 'externallyManaged/types';

export const setExternallyManagedNoticeSuppressed =
  actionCreator<PayloadIsSuppressed>(
    '[externallyManaged] SET_EXTERNALLY_MANAGED_NOTICE_SUPPRESSED'
  );
